import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import 'vue-class-component/hooks'; // import hooks type to enable auto-complete
import vuetify from './plugins/vuetify';
import { Auth } from '@aws-amplify/auth';
import awsExports from '@/aws-exports';
import i18n from './i18n';
import { awsConfiguration } from './aws-configuration';
import { PubSub } from './PubSubClass';
import { AWSIoTProvider } from '@aws-amplify/pubsub/lib/Providers';
import * as Sentry from '@sentry/vue';

Auth.configure(awsExports);
Vue.filter('yesno', function (value: boolean) {
  return value ? 'Yes' : 'No';
});
Vue.config.productionTip = false;
Vue.config.errorHandler = (err) => {
  console.log('Exception: ', err);
};
PubSub.addPluggable(
  new AWSIoTProvider({
    aws_pubsub_region: awsExports.aws_project_region,
    aws_pubsub_endpoint: `wss://${awsConfiguration.host}/mqtt`
  })
);

Sentry.init({
  Vue,
  dsn: 'https://a64fead5f7f8282c3cc734ef97e1167d@o4506507993481216.ingest.sentry.io/4506791329923072',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false
    })
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App)
}).$mount('#app');
